var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "image-gallery",
    on: {
      "dragover": function dragover($event) {
        $event.preventDefault();
        return _vm.onDragOver.apply(null, arguments);
      },
      "dragleave": function dragleave($event) {
        $event.preventDefault();
        return _vm.onDragLeave.apply(null, arguments);
      },
      "drop": function drop($event) {
        $event.preventDefault();
        return _vm.onGalleryDrop.apply(null, arguments);
      }
    }
  }, [_c('input', {
    ref: "mediaCaptureInput",
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "accept": "image/*,video/*",
      "capture": "environment",
      "multiple": ""
    },
    on: {
      "change": _vm.onMediaCaptured
    }
  }), !_vm.hasMedia && !_vm.readonly ? _c('div', {
    class: ['drop-area-empty', {
      'is-dragging': _vm.isDraggingOver,
      'is-disabled': _vm.readonly
    }]
  }, [_vm.isDraggingOver ? _c('div', {
    staticClass: "drag-overlay"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-upload")]), _c('p', [_vm._v(_vm._s(_vm.$t("cost.dragAndDropDocuments")))])], 1) : _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "drop-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('cost.dragAndDropDocuments'))
    }
  }), _c('span', {
    staticClass: "drop-or"
  }, [_vm._v(_vm._s(_vm.$t("or")))]), _c('div', {
    staticClass: "drop-actions"
  }, [_c('a', {
    staticClass: "upload-link",
    class: {
      disabled: _vm.readonly
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        !_vm.readonly && _vm.openMediaCapture();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("selectFiles")) + " ")])])])]) : _vm._e(), _vm.hasMedia ? _c('div', {
    staticClass: "image-gallery-content"
  }, [_vm.isDraggingOver && !_vm.readonly ? _c('div', {
    staticClass: "gallery-drag-overlay"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-upload")]), _c('p', [_vm._v(_vm._s(_vm.$t("cost.dragAndDropDocuments")))])], 1) : _vm._e(), _c('div', {
    staticClass: "gallery-header"
  }, [_c('v-spacer'), _vm.selectedImages.length || _vm.selectedVideos.length ? _c('v-btn', {
    staticClass: "download-btn",
    attrs: {
      "small": "",
      "text": "",
      "icon": _vm.$vuetify.breakpoint.mdAndDown
    },
    on: {
      "click": function click() {
        _vm.selectedImages.splice(0);

        _vm.selectedVideos.splice(0);
      }
    }
  }, [_vm.$vuetify.breakpoint.mdAndDown ? _c('v-icon', [_vm._v(" mdi-close ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t("gallery.removeSelection")) + " ")])], 1) : _vm._e(), _c('v-btn', {
    staticClass: "download-btn",
    attrs: {
      "small": "",
      "text": "",
      "icon": _vm.$vuetify.breakpoint.mdAndDown
    },
    on: {
      "click": _vm.download
    }
  }, [_vm.$vuetify.breakpoint.mdAndDown ? _c('v-icon', [_vm._v(" mdi-download ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t("download")) + " ")])], 1), !_vm.readonly ? _c('v-btn', {
    staticClass: "delete-btn",
    attrs: {
      "disabled": !_vm.selectedImages.length && !_vm.selectedVideos.length,
      "small": "",
      "text": "",
      "icon": _vm.$vuetify.breakpoint.mdAndDown
    },
    on: {
      "click": function click($event) {
        _vm.isDeleteDialogActive = true;
      }
    }
  }, [_vm.$vuetify.breakpoint.mdAndDown ? _c('v-icon', [_vm._v(" mdi-trash-can ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t("remove")) + " ")])], 1) : _vm._e()], 1), _c('transition-group', {
    staticClass: "gallery-grid",
    attrs: {
      "name": "gallery-tile",
      "tag": "div"
    }
  }, [_vm._l(_vm.videos, function (item) {
    return _c('div', {
      key: 'video' + item.id,
      staticClass: "image-item",
      class: {
        selected: _vm.isSelected(_vm.MediaGalleryItemType.VIDEO, item.id)
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openFullscreen(_vm.MediaGalleryItemType.VIDEO, item.id);
        },
        "contextmenu": function contextmenu($event) {
          $event.preventDefault();
          return _vm.toggleSelection(_vm.MediaGalleryItemType.VIDEO, item.id);
        },
        "touchstart": function touchstart($event) {
          return _vm.onTouchStart(_vm.MediaGalleryItemType.VIDEO, item.id);
        },
        "touchend": _vm.onTouchEnd
      }
    }, [_c('media-gallery-item', {
      attrs: {
        "value": item,
        "type": _vm.MediaGalleryItemType.VIDEO
      }
    }), _vm.isSelected(_vm.MediaGalleryItemType.VIDEO, item.id) ? _c('div', {
      staticClass: "selection-indicator"
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("mdi-check-circle")])], 1) : _vm._e()], 1);
  }), _vm._l(_vm.tempVideos, function (item) {
    return _c('div', {
      key: item._tempKey,
      staticClass: "image-item",
      class: {
        'is-temp': true
      },
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('media-gallery-item', {
      attrs: {
        "value": item.medium,
        "type": _vm.MediaGalleryItemType.VIDEO
      },
      on: {
        "created": function created($event) {
          return _vm.onTempVideoCreated(item._tempKey, $event);
        },
        "error": function error($event) {
          return _vm.removeTempVideo(item._tempKey);
        }
      }
    })], 1);
  }), _vm._l(_vm.images, function (item) {
    return _c('div', {
      key: 'image' + item.id,
      staticClass: "image-item",
      class: {
        selected: _vm.isSelected(_vm.MediaGalleryItemType.IMAGE, item.id)
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openFullscreen(_vm.MediaGalleryItemType.IMAGE, item.id);
        },
        "contextmenu": function contextmenu($event) {
          $event.preventDefault();
          return _vm.toggleSelection(_vm.MediaGalleryItemType.IMAGE, item.id);
        },
        "touchstart": function touchstart($event) {
          return _vm.onTouchStart(_vm.MediaGalleryItemType.IMAGE, item.id);
        },
        "touchend": _vm.onTouchEnd
      }
    }, [_c('media-gallery-item', {
      attrs: {
        "value": item,
        "type": _vm.MediaGalleryItemType.IMAGE
      }
    }), _vm.isSelected(_vm.MediaGalleryItemType.IMAGE, item.id) ? _c('div', {
      staticClass: "selection-indicator"
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("mdi-check-circle")])], 1) : _vm._e()], 1);
  }), _vm._l(_vm.tempImages, function (item) {
    return _c('div', {
      key: item._tempKey,
      staticClass: "image-item",
      class: {
        'is-temp': true
      }
    }, [_c('media-gallery-item', {
      attrs: {
        "value": item.medium,
        "type": _vm.MediaGalleryItemType.IMAGE
      },
      on: {
        "created": function created($event) {
          return _vm.onTempImageCreated(item._tempKey, $event);
        },
        "error": function error($event) {
          return _vm.removeTempImage(item._tempKey);
        }
      }
    })], 1);
  }), !_vm.readonly ? _c('div', {
    key: "upload-tile",
    staticClass: "image-item upload-tile",
    class: {
      disabled: _vm.readonly
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        !_vm.readonly && _vm.openMediaCapture();
      }
    }
  }, [_c('div', {
    staticClass: "upload-tile-content"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-upload")]), _c('div', {
    staticClass: "upload-tile-text"
  }, [_vm._v(_vm._s(_vm.$t("gallery.uploadMedia")))])], 1)]) : _vm._e()], 2)], 1) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('gallery.delete'),
      "isDialogActive": _vm.isDeleteDialogActive,
      "rightText": _vm.$t('delete'),
      "rightColor": 'error',
      "loading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "rightClick": _vm.handleDelete
    }
  }), _c('media-gallery-fullscreen', {
    attrs: {
      "media": _vm.fullscreenMedia,
      "index": _vm.fullscreenIndex,
      "isDeleteDisabled": _vm.readonly,
      "isDeleteLoading": _vm.isDeleteLoading
    },
    on: {
      "request-delete": _vm.handleFullscreenDelete,
      "download": _vm.downloadCurrent,
      "update:index": function updateIndex($event) {
        _vm.fullscreenIndex = $event;
      }
    },
    model: {
      value: _vm.isFullscreenActive,
      callback: function callback($$v) {
        _vm.isFullscreenActive = $$v;
      },
      expression: "isFullscreenActive"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }